import React from 'react';
import { OrderedList } from '../../../../../common/display/orderedList/OrderedList';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import PaperAndPenPng from '../images/paper-and-pen.png';
import PaperAndPenWebp from '../images/paper-and-pen.webp';
import PhonePng from '../images/phone.png';
import PhoneWebp from '../images/phone.webp';
import Section3Png from '../images/section3.png';
import Section3Webp from '../images/section3.webp';
import { useIntl } from '@/i18n';

const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={PaperAndPenPng}
              imageWebp={PaperAndPenWebp}
              imageAlt={t({
                id: 'benefits.rentLegal.modal.howItWorks.image1',
                defaultMessage: 'paper and pen',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.rentLegal.modal.howItWorks.paragraph1',
            defaultMessage: 'Enter your details',
          })}
        />
        <Item
          image={
            <ImageSource
              image={PhonePng}
              imageWebp={PhoneWebp}
              imageAlt={t({
                id: 'benefits.rentLegal.modal.howItWorks.image2',
                defaultMessage: 'opened phone',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.rentLegal.modal.howItWorks.paragraph2',
            defaultMessage: 'get your documents',
          })}
        />
        <Item
          image={
            <ImageSource
              image={Section3Png}
              imageWebp={Section3Webp}
              imageAlt={t({
                id: 'benefits.rentLegal.modal.howItWorks.image3',
                defaultMessage: 'download',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.rentLegal.modal.howItWorks.paragraph3',
            defaultMessage: 'or directly download',
          })}
        />
      </OrderedList>
    </div>
  );
};

export default HowItWorksTab;
